import { MetricAnomaly } from './types';

export function fmtValue(m: Pick<MetricAnomaly, 'unit'>, v: number | null | undefined, currency: string): string {
  if (v == null) return '—';
  if (m.unit === 'rate') return `${(v * 100).toFixed(1)}%`;
  // Per-unit money (cost per click, order value) keeps its cents; daily money is whole units.
  if (m.unit === 'money' || m.unit === 'money_per_day') {
    const digits = m.unit === 'money' || Math.abs(v) < 10 ? 2 : 0;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v); } catch { return v.toFixed(digits); }
  }
  if (m.unit === 'count_per_day') return Math.round(v).toLocaleString('en-US');
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

/** "+$1,234/day vs usual" in green or red; the metric named when it is revenue standing in for profit. */
export function fmtImpact(i: { metric: string | null; perDay: number | null; currency: string; explain?: string[] }): { text: string; color: string; note: string; explain: string[] } | null {
  if (i.perDay == null || !i.metric) return null;
  const money = fmtValue({ unit: 'money_per_day' }, Math.abs(i.perDay), i.currency);
  return {
    text: `${i.perDay >= 0 ? '+' : '−'}${money}/day`,
    color: i.perDay >= 0 ? '#059669' : '#DC2626',
    note: i.metric === 'revenue_per_day' ? 'revenue vs a usual day (profit not known yet)' : `${i.metric === 'net_profit_per_day' ? 'net profit' : 'profit'} vs a usual day`,
    explain: i.explain ?? [],
  };
}

export const shortDate = (iso: string): string => new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
